import { css } from 'styled-components';

const defaultFont = css`
  font-family: Inter sans-serif;
  font-style: normal;
  font-weight: normal;
`;

export default defaultFont;
